import $ from 'jquery';

$(document).ready(function () {
  acfvideoBlock();
});

function acfvideoBlock() {
  $('.js-acf-video-block').each(function () {});
}
